import { Component } from '@angular/core';

/** URL of the empty hop route `FilingFormContainerComponent.retryLoad` passes through. */
export const ROUTE_RELOAD_HOP_URL = '/mbrs/reload-hop';

/**
 * An intentionally empty page. Navigating here with `skipLocationChange` and
 * straight back is how a page is re-created at its own URL: Angular reuses a
 * component on a same-URL navigation, so `ngOnInit` would not re-run without
 * leaving the route first. Lives inside the `mbrs` shell so
 * `MainLayoutComponent` (and its toast outlet) stays mounted during the hop,
 * and loads nothing, so the hop costs no API call.
 */
@Component({
  selector: 'app-route-reload-hop',
  standalone: true,
  template: '',
})
export class RouteReloadHopComponent {}
